
export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {},

  // INFO: These values are used for our internal recommendation engine later on
  // categoryKeys aka. "Wheel of life"
  categoryKeys: [
    { id: 'self-care',text: 'Self-Care', icon: '' },
    { id: 'relationship', text: 'Relationship', icon: '' },
    { id: 'family-friends',text: 'Family & Friends', icon: '' },
    { id: 'finances', text: 'Finances', icon: '' },
    { id: 'home', text: 'Home', icon: '' },
    { id: 'career-business',text: 'Career / Business', icon: '' },
    { id: 'spiritual-contribution',text: 'Spiritual', icon: '' },
    { id: 'fun-recreation',text: 'Fun & Recreation', icon: '' },
    /*
    { id: 'purpose', icon: '' },
    { id: 'health-sports-nurtition', icon: '' },
    { id: 'love-romance', icon: '' },
    { id: 'time-productivity', icon: '' },
    { id: 'learning', icon: '' },
    */
  ],

  /*
  No  Life Area Description
  1 Career/Business What you do with your time to make money
  2 Finances and Wealth Managing your money
  3 Friends and Family  Important platonic relationships
  4 Fun, Recreation and Entertainment Guiltless, earned pleasure
  5 Health and Fitness  Exercise and nutrition
  6 Love Life Significant other
  7 Personal/Spiritual Development  Things you want to develop just for you
  8 Physical Environment  Your physical location i.e. your house, city, state, country
  */

  schema: {
    create({ name }, data) {
      return {
        name: data.name || '',
        sortidx: data.sortidx || 100,
        defaultTimeslotCollectionId: data.defaultTimeslotCollectionId || null,
        categoryKey: data.categoryKey || null,
      };
    },

    fields: {
      name: { validate_bolt_type: 'String' },
      sortidx: { validate_bolt_type: 'Number' },
      defaultTimeslotCollectionId: { validate_bolt_type: 'AnyID' },
      categoryKey: { validate_bolt_type: 'String' },
    }
  }
};
